import VersionsList from './VersionsList';

export default VersionsList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/VersionsList/index.js